import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { DomSanitizer } from '@angular/platform-browser';
import { InterfaceElementCosyDataTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-cosytype';
import BarcodeScanner from 'src/app/model/barcodeScanner';

const scanner = BarcodeScanner();

@Component({
  selector: 'app-cosy-entity',
  templateUrl: './cosy-entity.component.html',
  styleUrls: ['./cosy-entity.component.css']
})
export class CosyEntityComponent implements OnInit {
  @Input() ieEntity: InterfaceElement;
  private IE_TYPES = InterfaceElementTypes;
  private IE_COSY_TYPES = InterfaceElementCosyDataTypes;
  public ieEntityVisible: InterfaceElement[];
  private ieEntityDocument: InterfaceElement[];
  private ieEntityBarCode: InterfaceElement = null;
  private RTKeyShowNullable: boolean = false;
  private fileName;
  private pdfURL;
  public ieDocumentID;
  private pdfBase64: string = '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';
  private ieEntityBaseCSSStyle: number;
  


  constructor(
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    public uxControllerService: UXControllerService
  ) { }

  ngOnInit() {
    this.initFormEntity();
  }
  ngAfterContentInit() {
    if (this.ieEntityDocument != null)
      this.ieEntityDocument.forEach(element =>
        this.showNdownloadPDF(element, 'load', true));
  }

  ngDoCheck() {
    if (this.uxControllerService.isDynaFunctionCompleted && this.uxControllerService.dynaReferenceIEID == this.ieEntity.InterfaceElementID) {
      this.initFormEntity();
      if (this.ieEntityDocument != null)
        this.ieEntityDocument.forEach(element =>
          this.showNdownloadPDF(element, 'load', true));
      this.uxControllerService.isDynaFunctionCompleted = false;
    }
    if(!this.uxControllerService.isAPOS && this.uxControllerService.isAPOS !== null){
      setTimeout(() => {
      for(let ie of this.ieEntityVisible){
        if(this.uxControllerService.ieEntity.InterfaceElementGroup.controls[ie.InterfaceElementID].status == 'DISABLED'){
          this.ieEntity.InterfaceElementGroup.controls[ie.InterfaceElementID].disable();
        }
      
      }
    }, 100);
      this.uxControllerService.isAPOS = null;
    }
    
  }

  initFormEntity() {
    this.ieDocumentID = 'doc-' + this.ieEntity.InterfaceElementID;
    this.ieEntityBaseCSSStyle = 12 - this.ieEntity.Attributes.AssignedColumnWidth.split(' ')[0].replace('col-md-', '');
    this.RTKeyShowNullable = this.uxControllerService.RTKeyShowNullable;
    this.ieEntityVisible = this.ieEntity.InterfaceElements.filter(element =>
      element.Attributes.Visible && (element.CustomizeOptions == null ||
        element.CustomizeOptions != null && element.CustomizeOptions.Display != null && element.CustomizeOptions.Display)
    ).sort((ie1, ie2) => ie1.Attributes.DisplayOrder - ie2.Attributes.DisplayOrder);
    this.ieEntityDocument = this.ieEntity.InterfaceElements.filter(element =>
      element.TypeDID == this.IE_TYPES.InputText &&
      element.CosyDataTypeID == this.IE_COSY_TYPES.InputTextCosyDataTypeID &&
      element.CustomizeOptions != null && element.CustomizeOptions.Mode != null && element.CustomizeOptions.Mode == 'hidden'
    ).sort((ie1, ie2) => ie1.Attributes.DisplayOrder - ie2.Attributes.DisplayOrder);
    if(this.ieEntityDocument.length == 0) {
      let replace:string = 'col-md-' + (12 - this.ieEntityBaseCSSStyle)
      this.ieEntity.Attributes.AssignedColumnWidth = this.ieEntity.Attributes.AssignedColumnWidth.replace(replace, 'col-md-12');
      this.ieEntityBaseCSSStyle = 0;
    }
    this.ieEntityBarCode = this.ieEntity.InterfaceElements.find(element =>
      element.TypeDID == this.IE_TYPES.InputText &&
      element.Attributes.Enabled &&
      element.CustomizeOptions != null && (!element.CustomizeOptions.Display || !element.Attributes.Visible) &&
      element.CustomizeOptions.DisplayType != null && element.CustomizeOptions.DisplayType == 'barcode');
    if (this.ieEntityBarCode != null) this.initializeBarCodeScanner();
    if (this.uxControllerService.documentPdfBase64 != '') this.pdfBase64 = this.uxControllerService.documentPdfBase64;
  }

  showNdownloadPDF(ie: InterfaceElement, type: any, init: boolean) {

    let ieDocID;
    let value;

    value = (ie.Values != null && ie.Values.length > 0) ? ie.Values[0].Value : null;
    if (init) {
      ieDocID = ie.InterfaceElementID + '_init';
    } else {
      ieDocID = 'doc-' + ie.InterfaceElementID;
    }



    //  eingefügt für ProcDoc  //
    if (ieDocID == 'be09adc8-6182-4a34-8311-60df1ea6c4dc_init') {
      let pagecount: number[] = this.uxControllerService.getIEformEntity('7246c5b2-09c5-4628-b2b7-824efc5e97a3').Values[0].Value.split("/");
      if (pagecount.length > 1) this.uxControllerService.page = pagecount[1] - pagecount[0] + 1;
    }
    //  Ende ProcDoc  // this.pdfURLBlob = this.sanitizor.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob)); //

    if (this.uxControllerService.documentID != value) {
      this.uxControllerService.page = 0;
      this.uxControllerService.zoom = 'auto';
      this.uxControllerService.rotation = 0;
      this.uxControllerService.documentPdfBase64 = '';
      this.uxControllerService.documentID = '';
    }

    if (this.uxControllerService.documentPdfBase64 == '') {
      this.cosyCommunicationControllerService.showNdownloadPDF(value).subscribe((res: any) => {
          const linkSource = 'data:application/pdf;base64,' + res['b64Data'];
          this.pdfBase64 = res['b64Data'];
          this.fileName = res['fileName'];
          this.uxControllerService.documentPdfBase64 = this.pdfBase64;
          this.uxControllerService.documentID = value;
          this.pdfURL = this.base64ToArrayBuffer(res['b64Data']);
          let blob = new Blob([this.pdfURL], { type: 'application/pdf' });
          if (type == 'download') {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.fileName
            link.click();
          } else if (type == 'show') {
            var displayValue = document.getElementById(ieDocID).style.display;
            if (displayValue == 'block') {
              document.getElementById(ieDocID).style.display = 'none';
            } else if (displayValue == 'none') {
              document.getElementById(ieDocID).style.display = 'block';
            }
          } else if (type == 'upload') {
            console.log('need to upload');
          }
        }
      );
    }
    else {
      let blob = new Blob([this.pdfURL], { type: 'application/pdf' });
      if (type == 'download') {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.fileName
        link.click();
      } else if (type == 'show') {
        var displayValue = document.getElementById(ieDocID).style.display;
        if (displayValue == 'block') {
          document.getElementById(ieDocID).style.display = 'none';
        } else if (displayValue == 'none') {
          document.getElementById(ieDocID).style.display = 'block';
        }
      } else if (type == 'upload') {
        console.log('need to upload');
      }
    }
  }


  base64ToArrayBuffer(base64) {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  initializeBarCodeScanner() {
    scanner.on(data => {
      let ieRef: InterfaceElement;
      let ieRefID: String = this.ieEntityBarCode.CustomizeOptions.Properties.RefID;
      if (ieRefID != null) ieRef = this.getInterfaceElementByID(this.uxControllerService.ieEntity.InterfaceElements, ieRefID);
      if (ieRef.Values[0].Value == 'true') {
        console.log(data);
        if (this.ieEntityBarCode.Attributes.OnChangeUAID != null) {
          this.uxControllerService.fetchIEUserAction(
            this.ieEntityBarCode.Attributes.OnChangeUAID,
            this.ieEntityBarCode,
            data,
            null,
            null,
            null,
            this.ieEntity.InterfaceElementGroup,
            null
          )
        }
      }
    });
  }

  ///////////////////
  //
  // Utilities for e.g. BarcodeScannner
  //
  ///////////////////

  getInterfaceElement(ieList: InterfaceElement[], displayType: string): InterfaceElement {
    let ieIEReturn: InterfaceElement = null;
    ieList.forEach(ieIE => {
      let ieIEHelp: InterfaceElement = null;
      if (ieIEReturn == null && ieIE.CustomizeOptions != null && ieIE.CustomizeOptions.DisplayType == displayType) ieIEReturn = ieIE;
      if (ieIEReturn == null && ieIE.InterfaceElements != null) ieIEHelp = this.getInterfaceElement(ieIE.InterfaceElements, displayType);
      if (ieIEReturn == null && ieIEHelp != null) ieIEReturn = ieIEHelp;
    })
    return ieIEReturn;
  }

  getInterfaceElementByID(ieList: InterfaceElement[], refIE: String): InterfaceElement {
    let ieIEReturn: InterfaceElement = null;
    ieList.forEach(ieIE => {
      let ieIEHelp: InterfaceElement = null;
      if (ieIEReturn == null && ieIE.InterfaceElementID == refIE) ieIEReturn = ieIE;
      if (ieIEReturn == null && ieIE.InterfaceElements != null) ieIEHelp = this.getInterfaceElementByID(ieIE.InterfaceElements, refIE);
      if (ieIEReturn == null && ieIEHelp != null) ieIEReturn = ieIEHelp;
    })
    return ieIEReturn;
  }

  ///////////////////
  //
  // End Utilities for e.g. BarcodeScannner
  //
  ///////////////////


}
